// Timezone assumption: all meeting timestamps are stored as UTC and displayed
// using the viewer's local wall-clock time. The Maldives operate at UTC+5 with
// no DST, so for Maldivian users the displayed time will always match local time.
const DV_WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const DV_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function formatDvDate(iso: string): string {
  const d = new Date(iso);
  return `${DV_WEEKDAYS[d.getDay()]}, ${d.getDate()} ${DV_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDvTime(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function meetingNumber(year: number, sequence: number): string {
  return `${year}/${sequence}`;
}
